module.exports = __webpack_public_path__ + "static/media/logo_fill_white.3b8030c7.svg";